<template>
  <div
    class="flex flex-row items-center space-x-1 text-sm text-text align-middle"
  >
    <span class="inline-flex items-center -space-x-2.5 relative">
      <Avatar
        v-for="(entry, index) in displayAvatars"
        :key="entry.userId"
        :user="{
          username: entry.username,
          avatar: entry.avatar,
          id: entry.userId,
        }"
        size="sm"
        :style="{
          'z-index': displayAvatars.length - index,
        }"
      />
    </span>

    <span v-if="shouldShowOnlineCount" class="text-sm font-sans">{{
      formatCompactNumber(onlineNow, userStore.userLocale)
    }}</span>

    <span v-if="shouldShowOnlineCount" class="text-sm font-sans">{{
      $t("channel.onlineUsers.status")
    }}</span>
    <div
      class="block rounded-full size-2"
      :class="onlineStatusIndicatorClass"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user.store";
import { formatCompactNumber } from "@/utils/format";
import { computed } from "vue";
import Avatar from "./me/avatar.vue";
import { useOnlineNow } from "@/composables/global/use-online-now";
import { useRecentAvatars } from "@/composables/global/use-recent-avatars";
import { useAblySdk } from "@/composables/ably/use-ably-sdk";

const userStore = useUserStore();
const { onlineNow, isOnlineNowLoaded } = useOnlineNow();
const { recentAvatars } = useRecentAvatars();
const ablySdk = useAblySdk();

const displayAvatars = computed(() => recentAvatars.value.slice(0, 5));
const isAblyConnected = computed(
  () => ablySdk.connectionState.value === "connected",
);
const shouldShowOnlineCount = computed(
  () => isAblyConnected.value && isOnlineNowLoaded.value,
);
const onlineStatusIndicatorClass = computed(() => {
  switch (ablySdk.connectionState.value) {
    case "connected":
      return "bg-fill-success";
    case "connecting":
      return "bg-fill-tertiary animate-pulse";
    case "disconnected":
    case "suspended":
    case "failed":
      return "bg-basics-accent-red";
    default:
      return "bg-fill-tertiary";
  }
});
</script>
